"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Colors = exports.ColorFamily = exports.ColorAliases = void 0;
var Colors = /*#__PURE__*/function (Colors) {
  Colors["APRICOT_10"] = "#FCF0ED";
  Colors["APRICOT_20"] = "#F8D9CF";
  Colors["APRICOT_30"] = "#F4C1B1";
  Colors["APRICOT_50"] = "#ED9D85";
  Colors["APRICOT_60"] = "#E98567";
  Colors["APRICOT_80"] = "#822022";
  Colors["EBONY_60"] = "#4B5E63";
  Colors["EBONY_70"] = "#3C4C50";
  Colors["EBONY_80"] = "#2E393C";
  Colors["EBONY_90"] = "#1F2729";
  Colors["EBONY_90_A20"] = "#1F272933";
  Colors["GREEN_10"] = "#DAF4E6";
  Colors["GREEN_20"] = "#A3E8C3";
  Colors["GREEN_30"] = "#65CB89";
  Colors["GREEN_50"] = "#278753";
  Colors["GREEN_60"] = "#126E33";
  Colors["GREEN_80"] = "#004620";
  Colors["GREY_05"] = "#FAFAFA";
  Colors["GREY_10"] = "#EEEEEE";
  Colors["GREY_20"] = "#D7D6D4";
  Colors["GREY_30"] = "#BBB9B3";
  Colors["GREY_30_A30"] = "#BBB9B34D";
  Colors["GREY_50"] = "#A09D97";
  Colors["GREY_50_A30"] = "#9B988F4D";
  Colors["GREY_60"] = "#86847E";
  Colors["GREY_70"] = "#726F66";
  Colors["GREY_80"] = "#545149";
  Colors["IVORY_05"] = "#FCFAF2";
  Colors["IVORY_10"] = "#F7F3E7";
  Colors["IVORY_20"] = "#EFE9D7";
  Colors["IVORY_30"] = "#E8DFCA";
  Colors["MARINE_10"] = "#D4FAFF";
  Colors["MARINE_20"] = "#A3E9F2";
  Colors["MARINE_30"] = "#81D4DF";
  Colors["MARINE_50"] = "#32B2C4";
  Colors["MARINE_60"] = "#2C9EAC";
  Colors["MARINE_80"] = "#004E58";
  Colors["PEACH_10"] = "#FCEDE3";
  Colors["PEACH_20"] = "#FBE1CF";
  Colors["PEACH_30"] = "#FCD4B8";
  Colors["PEACH_50"] = "#F6B98F";
  Colors["PEACH_60"] = "#F3A570";
  Colors["PEACH_80"] = "#863600";
  Colors["PURPLE_10"] = "#F8E8FC";
  Colors["PURPLE_20"] = "#F7D6FF";
  Colors["PURPLE_30"] = "#E09BF0";
  Colors["PURPLE_50"] = "#AD4CC6";
  Colors["PURPLE_60"] = "#88379C";
  Colors["PURPLE_80"] = "#612270";
  Colors["RED_10"] = "#FDECEB";
  Colors["RED_20"] = "#FFC4C1";
  Colors["RED_30"] = "#F6928D";
  Colors["RED_50"] = "#F1564E";
  Colors["RED_60"] = "#C61D15";
  Colors["RED_80"] = "#890600";
  Colors["SAGE_10"] = "#E9F3ED";
  Colors["SAGE_20"] = "#CFE0D8";
  Colors["SAGE_30"] = "#85A495";
  Colors["SAGE_40"] = "#628373";
  Colors["SAGE_50"] = "#455C51";
  Colors["SAGE_60"] = "#3A4940";
  Colors["WHITE"] = "#FFFFFF";
  Colors["WHITE_A40"] = "#FFFFFF66";
  Colors["YELLOW_10"] = "#FEF0D9";
  Colors["YELLOW_20"] = "#FFE0AC";
  Colors["YELLOW_30"] = "#FDD086";
  Colors["YELLOW_50"] = "#FCB643";
  Colors["YELLOW_60"] = "#E99915";
  Colors["YELLOW_80"] = "#734700";
  return Colors;
}({});
exports.Colors = Colors;
var ColorAliases = /*#__PURE__*/function (ColorAliases) {
  ColorAliases["DANGER"] = "#F1564E";
  ColorAliases["DEFAULT"] = "#9B988F";
  ColorAliases["SUCCESS"] = "#278753";
  ColorAliases["WARNING"] = "#FCB643";
  ColorAliases["PRIMARY"] = "#32B2C4";
  return ColorAliases;
}({});
exports.ColorAliases = ColorAliases;
var ColorFamily = {
  IVORY: 'ivory',
  GREY: 'grey',
  WHITE: 'white',
  SAGE: 'sage',
  GREEN: 'green',
  YELLOW: 'yellow',
  RED: 'red',
  MARINE: 'marine',
  PURPLE: 'purple',
  PEACH: 'peach',
  APRICOT: 'apricot'
};
exports.ColorFamily = ColorFamily;